// frontend/src/pages/AdminCronJobs.jsx
import { useEffect, useState } from "react";
import api from "../api";

export default function AdminCronJobs() {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    api.get("/admin/cronjobs").then(res => {
      setJobs(res.data);
      setLoading(false);
    }).catch(() => {
      setJobs([]);
      setLoading(false);
    });
  }, []);

  const loadRuns = async (jobId) => {
    setSelectedJob(jobId);
    setRuns([]);
    setLoading(true);
    try {
      const res = await api.get(`/admin/cronjobs/${jobId}/runs`);
      setRuns(res.data);
    } catch {
      setRuns([]);
    }
    setLoading(false);
  };

  const handleAction = async (jobId, action) => {
    setActionLoading(true);
    setError("");
    try {
      await api.post(`/admin/cronjobs/${jobId}/${action}`);
      // Refresh jobs
      const res = await api.get("/admin/cronjobs");
      setJobs(res.data);
      if (selectedJob === jobId) await loadRuns(jobId);
    } catch (err) {
      setError(err?.response?.data?.error || "Aktion fehlgeschlagen.");
    }
    setActionLoading(false);
  };

  return (
    <div style={{width:'100vw',margin:0,padding:0,display:'flex',justifyContent:'center', position:'relative', left:'-120px'}}>
      <div style={{padding:32,maxWidth:900,width:'100%'}}>
        <h2 style={{marginBottom:18}}>CronJobs Übersicht</h2>
        {loading ? <div>Lade CronJobs ...</div> : (
          <table style={{width:'100%',borderCollapse:'collapse',marginBottom:32}}>
            <thead>
              <tr style={{background:'#222',color:'#32CD89'}}>
                <th style={{padding:8}}>Name</th>
                <th style={{padding:8}}>Beschreibung</th>
                <th style={{padding:8}}>Intervall</th>
                <th style={{padding:8}}>Nächster Lauf</th>
                <th style={{padding:8}}>Letzter Lauf</th>
                <th style={{padding:8}}>Status</th>
                <th style={{padding:8}}>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {jobs.map(job => (
                <tr key={job.id} style={{borderBottom:'1px solid #333'}}>
                  <td style={{padding:8}}>{job.name}</td>
                  <td style={{padding:8}}>{job.description}</td>
                  <td style={{padding:8}}>{job.schedule}</td>
                  <td style={{padding:8}}>{job.running && job.nextRunAt ? new Date(job.nextRunAt).toLocaleString() : '-'}</td>
                  <td style={{padding:8}}>{job.lastRunAt ? new Date(job.lastRunAt).toLocaleString() : '-'}</td>
                  <td style={{padding:8}}>{job.running ? 'Aktiv' : 'Gestoppt'}</td>
                  <td style={{padding:8}}>
                    <button disabled={actionLoading || job.running} onClick={()=>handleAction(job.id, 'start')} style={{marginRight:6}}>Start</button>
                    <button disabled={actionLoading || !job.running} onClick={()=>handleAction(job.id, 'stop')} style={{marginRight:6}}>Stop</button>
                    <label style={{marginLeft:8}}>
                      <input type="checkbox" checked={!!job.autostart} onChange={async e => {
                        setActionLoading(true);
                        await api.post(`/admin/cronjobs/${job.id}/autostart`, { autostart: e.target.checked });
                        const res = await api.get("/admin/cronjobs");
                        setJobs(res.data);
                        setActionLoading(false);
                      }} /> Autostart
                    </label>
                    <button disabled={actionLoading} onClick={()=>handleAction(job.id, 'run')} style={{marginRight:6}}>Manuell ausführen</button>
                    <button onClick={()=>loadRuns(job.id)}>History</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {error && <div style={{color:'red',marginBottom:12}}>{error}</div>}
        {selectedJob && (
          <div style={{marginTop:24}}>
            <h3>History für Job #{selectedJob}</h3>
            {loading ? <div>Lade History ...</div> : (
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead>
                  <tr style={{background:'#222',color:'#32CD89'}}>
                    <th style={{padding:8}}>Start</th>
                    <th style={{padding:8}}>Ende</th>
                    <th style={{padding:8}}>Status</th>
                    <th style={{padding:8}}>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {runs.map(run => (
                    <tr key={run.id} style={{borderBottom:'1px solid #333'}}>
                      <td style={{padding:8}}>{new Date(run.startedAt).toLocaleString()}</td>
                      <td style={{padding:8}}>{run.finishedAt ? new Date(run.finishedAt).toLocaleString() : '-'}</td>
                      <td style={{padding:8}}>{run.status}</td>
                      <td style={{padding:8}}>{run.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
